import React from 'react';
import PropTypes from 'prop-types';

const FormStepCollectionStateContext = React.createContext(undefined);
const FormStepCollectionDispatchContext = React.createContext(undefined);


export const SET_DISABLED = 'set-disabled';
export const SET_STEPS = 'set-steps';
export const SET_ERROR = 'set-error';
export const SET_ACTIVE_STEP = 'set-active-step';

function init(initialState) {
  return {
    steps: null,
    activeStep: 0,
    error: null,
    editMode: false,
    ...initialState,
  };
}

function setActiveStep(activeStep) {
  return {
    type: SET_ACTIVE_STEP,
    activeStep,
  };
}

function setDisabled(disabled) {
  return {
    type: SET_DISABLED,
    disabled,
  };
}
function setSteps(steps) {
  return {
    type: SET_STEPS,
    steps,
  };
}

function reducer(state, action) {
  switch (action.type) {
    case SET_ACTIVE_STEP: {
      const { activeStep } = action;
      return {
        ...state,
        activeStep,
      };
    }
    case SET_ERROR: {
      const { message } = action;
      return {
        ...state,
        error: message,
      };
    }
    case SET_STEPS: {
      const { steps } = action;
      return {
        ...state,
        steps,
      };
    }
    case SET_DISABLED: {
      const { disabled } = action;
      return {
        ...state,
        disabled,
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

function FormStepCollectionProvider({ children, initialState }) {
  const [state, dispatch] = React.useReducer(reducer, initialState, init);
  return (
    <FormStepCollectionStateContext.Provider value={state}>
      <FormStepCollectionDispatchContext.Provider value={dispatch}>
        {children}
      </FormStepCollectionDispatchContext.Provider>
    </FormStepCollectionStateContext.Provider>
  );
}

const useFormStepCollectionContext = () => {
  const dispatch = React.useContext(FormStepCollectionDispatchContext);
  const state = React.useContext(FormStepCollectionStateContext);

  if (!dispatch) {
    throw new Error('useFormStepCollectionContext must be called from FormStepCollectionProvider');
  }

  if (!state) {
    throw new Error('useFormStepCollectionContext must be called from FormStepCollectionProvider');
  }

  return { dispatch, state };
};

FormStepCollectionProvider.defaultProps = {
  initialState: init(),
};

FormStepCollectionProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  initialState: PropTypes.object,
};

export {
  FormStepCollectionProvider,
  useFormStepCollectionContext,
  setActiveStep,
  setDisabled,
  setSteps,
};
